import { FilterProps } from '@awaze/design-system.components.filter'
import { TmsContextType } from '@awaze/mfe-common.contexts.tms'
import { AggregationFeatures } from '@awaze/mfe-common.types-and-mocks.one-search-client'

import { OPTIMIZELY_EVENTS } from '@/constants'
import { FeatureGroupIds } from '@/containers/Filters/Filters.types'
import { OptimizelyDecisionsProps } from '@/context/optimizely-decisions-context'
import { Assert } from '@/utils/assert'
import { trackClientSideOptimizelyEvent } from '@/utils/optimizely/trackOptimizelyEvent'

import { fireFacetClearAllEvent } from './TMSEvents/fireFacetClearAllEvent'
import { fireFacetRemovedEvent } from './TMSEvents/fireFacetRemovedEvent'
import { fireFacetSelectedEvent } from './TMSEvents/fireFacetSelectedEvent'

export interface FireFacetToggledProps {
  allFeatures: Array<FilterProps | AggregationFeatures>
  appliedFeatures: Array<string>
  clickedFeature: {
    featureId: string
    featureGroupId: FeatureGroupIds
  }
  tms: TmsContextType
  optiContext: OptimizelyDecisionsProps
}

export const fireFacetToggled = ({
  allFeatures,
  appliedFeatures,
  clickedFeature: {
    featureId: clickedFeatureId,
    featureGroupId: clickedFeatureGroupId,
  },
  tms,
  optiContext,
}: FireFacetToggledProps): void => {
  const isFeatureApplied = appliedFeatures.includes(clickedFeatureId)

  if (clickedFeatureGroupId === 'popularFeatures') {
    trackClientSideOptimizelyEvent(
      OPTIMIZELY_EVENTS.POPULAR_FEATURE_CLICK,
      optiContext,
    )
  }

  trackClientSideOptimizelyEvent(OPTIMIZELY_EVENTS.FEATURE_CLICK, optiContext)

  if (isFeatureApplied) {
    const clickedFeature = {
      featureGroup: clickedFeatureGroupId,
      featureLabel: clickedFeatureId,
    }

    fireFacetRemovedEvent({
      clickedFeature,
      tms,
    })
  } else {
    const foundFeature = allFeatures.find(
      ({ featureId: currentFeatureId }) =>
        currentFeatureId.toString() === clickedFeatureId.toString(),
    )

    Assert.defined(foundFeature, 'Was not able to find toggled feature')

    const { count: matchedFeatureCount } = foundFeature

    const clickedFeature = {
      featureCount: matchedFeatureCount,
      featureGroup: clickedFeatureGroupId,
      featureLabel: clickedFeatureId,
    }

    fireFacetSelectedEvent({
      clickedFeature,
      tms,
    })
  }
}

export interface FireFacetClearAllProps {
  tms: TmsContextType
}

export const fireFacetClearAll = ({ tms }: FireFacetClearAllProps): void => {
  fireFacetClearAllEvent({
    tms,
  })
}

export interface FireChipRemovedProps {
  clickedFeature: {
    featureId: string
    featureGroupId: FeatureGroupIds
  }
  tms: TmsContextType
}

export const fireChipRemoved = ({
  clickedFeature: { featureId, featureGroupId },
  tms,
}: FireChipRemovedProps): void => {
  const clickedFeature = {
    featureGroup: featureGroupId,
    featureLabel: featureId,
  }

  fireFacetRemovedEvent({
    clickedFeature,
    tms,
  })
}
